import { useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, TextField } from "@material-ui/core";
import { validateBlueprintName, checkBlueprintNameExits } from "../bluePrintComponents/SystemModel/helpers";
import { getHistoryData } from "../../../store/history/selectors";
import { updateBlueprintSlugDetails } from "../../../store/global/actions";
import { getBlueprintDetails } from "../../../store/global/selectors";
import { getRecentHistory } from "../../../store/history/actions";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { useHistory } from "react-router-dom";

export const RenameBlueprintForm = (props) => {
    const { onClose, onCompletion } = props;
    const { register, getValues, trigger, reset, errors, control } = useForm();
    const dispatch = useDispatch();
    const history = useHistory();
    const historyData = useSelector(getHistoryData);
    const { title = "", description = "", docid } = useSelector(getBlueprintDetails);
    const bpDetails = useSelector(getBlueprintDetails);
    const { title: presentBlueprintName, id } = useSelector(getBlueprintDetails);
    const [validationError, setValidationError] = useState(false)
    const [blueprintNameValidation, setBlueprintNameValidation] = useState(null);

    useEffect(() => {
        dispatch(getRecentHistory());
        reset({ title, description });
        return () => {
            reset({ title, description });
        };
    }, []);

    useEffect(() => {
    }, [validationError]);

    const convertStrToSlug = text => {
        let mytext = text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
        return mytext;
    }

    const onSave = () => {
        const { title, description } = getValues();
        const [, , bpName, currentTag] = history.location.pathname.split("/");

        const validationMessage = validateBlueprintName(title);
        setBlueprintNameValidation(validationMessage);

        if (validationMessage && validationMessage.length > 0) {
            setValidationError(true);
            return
        }

        const blueprintNames = historyData.myBlueprints.map(blueprint => {
            if (blueprint.title !== presentBlueprintName && blueprint.id !== id) return blueprint.title
        }).filter(i => i)

        const blueprintNameExists = checkBlueprintNameExits({ title, blueprintNames })
        if (blueprintNameExists) {
            setBlueprintNameValidation("Blueprint with the given name exists");
            setValidationError(true);
            return
        }

        dispatch(updateBlueprintSlugDetails({
            id: title,
            title,
            description: description === undefined ? "" : description
        }));

        const newSlug = convertStrToSlug(title);
        history.push(`/blueprint/${newSlug}-${docid}/${currentTag}`);
        // dispatch(renameBlueprint(bpName, title, bpDetails, description));
        
        onCompletion(title, description);
    }

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}
                    autoFocus
                    size="small"
                    error={validationError}
                    name="title"
                    fullWidth
                    type={"string"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    helperText={validationError === true ? blueprintNameValidation : ""}
                    inputRef={register({ required: true, validate: validateBlueprintName })}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    id="description"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={Boolean(errors?.description)}
                    type={"text"}
                    fullWidth
                    rows={4}
                    multiline={true}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    name="description"
                    inputRef={register}
                />
            </Grid>


            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel onUpdate={onSave} onCancel={onClose} />
            </Grid>
        </Grid>
    )

}